module.exports = __webpack_public_path__ + "static/media/pulse-power-logo.381b387e.svg";